// @flow

import React, { memo } from 'react';
import Styles from './styles';

type Props = {
  currentPage : number,
  onChangePage : (type : string) => void,
  listsData : any,
  onBackToHome : () => void,
};

export default memo(({
  currentPage,
  onChangePage,
  nextPageLink,
  onBackToHome,
} : Props) => (
  <Styles className="paginationWrapper">
    <div className="buttonsWrapper selectableRow">
      {
        nextPageLink &&
          <button
            onClick={() => onChangePage('next')}
            className="next selectableItem"
            clickable="true"
          >
            <p>صفحه بعد</p>
          </button>
      }
      {
        (currentPage > 1) &&
          <button
            onClick={onBackToHome}
            className="selectableItem"
            clickable="true"
          >
            <p>صفحه اول</p>
          </button>
      }
    </div>
  </Styles>
));
